import type {StatusBadgeProps} from 'shells/status-badge/status-badge';

import type {EnrollmentFormEnumStatus} from 'nutshell-graphql-types';

export const getIsEnrollmentFormDisabled = (status: EnrollmentFormEnumStatus) => {
    const disabledStatuses = [
        'UNDER_REVIEW',
        'SUBMISSION_VALIDATING',
        'SUBMISSION_ACCEPTED',
        'CONTACT_SUPPORT',
    ];

    return disabledStatuses.includes(status);
};

export const getEnrollmentStatusBadge = (status: EnrollmentFormEnumStatus): StatusBadgeProps => {
    switch (status) {
        case 'CONTACT_SUPPORT':
            return {level: 'alert', text: 'Registration declined'};
        case 'IN_PROGRESS':
            return {level: 'warning', text: 'In progress'};
        case 'UNDER_REVIEW':
        case 'SUBMISSION_VALIDATING':
            return {level: 'warning', text: 'Under Review'};
        case 'SUBMISSION_ACCEPTED':
            return {level: 'success', text: 'Approved'};
        case 'NOT_STARTED':
        default:
            return {level: 'info--grey', text: 'Not registered'};
    }
};

export const getShouldShowErrorBanner = (status: EnrollmentFormEnumStatus): boolean => {
    return (
        status === 'CONTACT_SUPPORT' ||
        status === 'UNDER_REVIEW' ||
        status === 'SUBMISSION_VALIDATING'
    );
};

export const getGovernmentRegistrationTypeTitle = (registrationType: string) => {
    switch (registrationType) {
        case 'EIN':
            return 'Employer Identification Number (EIN)';
        case 'CBN':
            return 'Canadian Business Number (CBN)';
        case 'CN':
            return 'Company Number (CN)';
        case 'ACN':
            return 'Australian Company Number form ASIC (ACN)';
        case 'CIN':
            return 'Corporate Identity Number (CIN)';
        case 'VAT':
            return 'VAT Number (VAT)';
        case 'VATRN':
            return 'VAT Registration Number (VATRN)';
        case 'RN':
            return 'Registration Number (RN)';
        default:
            return 'Government Registration #';
    }
};
